// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_gf-0";
export var fileCarousel = "_gf-2";
export var removeFileButton = "_gf-1";